import { Button } from "react-bootstrap";
import { SearchBox } from "../SearchBox/SearchBox";
import { MobileDrawer } from "../Navigation/MobileDrawer";
import { SpaceSwitcher } from "../Spaces/Wrapper/SpaceSwitcher";
import { UserMenu } from "./UserMenu";
import { useSidebar } from "../../context/SidebarContext";

export const Header = () => {
  const { collapsed, expand } = useSidebar();

  return (
    <header className="header mt-3 mb-4">
      <div className="container-fluid">
        <div className="d-flex align-items-center justify-content-between gap-2">
          <MobileDrawer />
          {collapsed && (
            <Button
              variant="none"
              className="sidebar-expand-btn d-none d-lg-flex align-items-center px-1 py-0 flex-shrink-0"
              onClick={expand}
              aria-label="Expand sidebar"
              title="Expand sidebar"
            >
              <i className="bi bi-list fs-2" aria-hidden="true"></i>
            </Button>
          )}
          <SearchBox />

          <div className="d-flex flex-fill align-items-center justify-content-end gap-2">
            <SpaceSwitcher />
            <div className="d-none d-lg-block">
              <UserMenu />
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
